import { BusinessMerchantSchema } from 'services/businesses';
import { prysymProcessor } from 'entities/merchantServices';

export const isMerchantValid = (merchant: BusinessMerchantSchema | null) =>
  merchant?.processor_MerchantsId === prysymProcessor.value ||
  (merchant?.contact?.firstName &&
    merchant?.contact?.lastName &&
    merchant?.contact?.phone &&
    merchant?.contact?.email);
